export enum CFType {
    CHECKBOX = "CHECKBOX",
    DATE = "DATE",
    DATETIME = "DATETIME",
    ENUM = "ENUM",
    FLOAT = "FLOAT",
    INT = "INT",
    SIGNATURE = "SIGNATURE",
    STRING = "STRING",
    TEXT_AREA = "TEXTAREA",
    TIME = "TIME",
    URL = "URL"
}
